// @core/api/endpoints/notifications/get_channel.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ChannelResponse,
} from '../../../types/notifications';

const BASE_PATH = '/notifications';

/**
 * Get channel by ID
 * Retrieves a specific notification channel by its unique identifier. Returns the channel configuration and current status.
 */
export async function GetChannel(
  channel_id: string,
  options?: RequestOptions
): Promise<ChannelResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/channels/:channel_id`;
  requestPath = requestPath.replace(':channel_id', encodeURIComponent(channel_id));
  const requestOptions = options;
  return client.get<ChannelResponse>(requestPath, { ...requestOptions });
}
